import { colonyAPI } from '@/api';
import * as types from './mutation-types';

export default {
  downloadOptinsReport({ commit, dispatch }, privacyTypes) {
    commit(types.DOWNLOAD_OPTINS_REQUEST);

    colonyAPI
      .post('/privacy/optins/download/', privacyTypes)
      .then(() => {
        commit(types.DOWNLOAD_OPTINS_SUCCESS);
        dispatch(
          'toast/success',
          'Your request has been successfully received. You will be notified when the file is ready to download.',
          { root: true },
        );
      })
      .catch(error => {
        commit(types.DOWNLOAD_OPTINS_FAILURE, error);
        dispatch(
          'toast/error',
          'Your request to download messages failed. Please contact support for more help.',
          { root: true },
        );
      });
  },
  createOptins({ commit }, { company, payload }) {
    commit(types.CREATE_OPTINS_REQUEST);

    colonyAPI
      .post(`/privacy/optins/system/${company.id}/`, payload)
      .then(response => commit(types.CREATE_OPTINS_SUCCESS, response.data))
      .catch(error => commit(types.CREATE_OPTINS_FAILURE, error.error));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/privacy/actions.js